define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MPestAnimalsDomain = void 0;
    class MPestAnimalsDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: MPestAnimalsDomain.NoneObserved, value: "None observed" },
                    { key: MPestAnimalsDomain.AustralianPlagueLocustChortoicetusTerminifera, value: "Australian plague locust (Chortoicetus terminifera)" },
                    { key: MPestAnimalsDomain.CatOtherThanADomesticCatFelisCatus, value: "Cat, other than a domestic cat (Felis catus)" },
                    { key: MPestAnimalsDomain.DingoCanisFamiliarisDingo, value: "Dingo (Canis familiaris dingo)" },
                    { key: MPestAnimalsDomain.DogOtherThanADomesticDogCanisFamiliaris, value: "Dog, other than a domestic dog (Canis familiaris)" },
                    { key: MPestAnimalsDomain.EuropeanFoxVulpesVulpes, value: "European fox (Vulpes vulpes)" },
                    { key: MPestAnimalsDomain.EuropeanRabbitDomesticAndWildBreedsOryctolagusCuniculus, value: "European rabbit (domestic and wild breeds) (Oryctolagus cuniculus)" },
                    { key: MPestAnimalsDomain.FeralChitalAxisDeerAxisAxis, value: "Feral chital (axis) deer (Axis axis)" },
                    { key: MPestAnimalsDomain.FeralFallowDeerDamaDama, value: "Feral fallow deer (Dama dama)" },
                    { key: MPestAnimalsDomain.FeralPigSusScrofa, value: "Feral pig (Sus scrofa)" },
                    { key: MPestAnimalsDomain.FeralRedDeerCervusElaphus, value: "Feral red deer (Cervus elaphus)" },
                    { key: MPestAnimalsDomain.FeralRusaDeerCervusTimorensis, value: "Feral rusa deer (Cervus timorensis)" },
                    { key: MPestAnimalsDomain.GoatOtherThanADomesticGoatCapraHircus, value: "Goat, other than a domestic goat (Capra hircus)" },
                    { key: MPestAnimalsDomain.MigratoryLocustLocustaMigratoria, value: "Migratory locust (Locusta migratoria)" },
                    { key: MPestAnimalsDomain.SpurThroatedLocustAustracrisGuttulosa, value: "Spur-throated locust (Austracris guttulosa)" },
                    { key: MPestAnimalsDomain.YellowCrazyAntAnoplolepisGracilipes, value: "Yellow crazy ant (Anoplolepis gracilipes)" },
                    { key: MPestAnimalsDomain.OtherDeclaredPestAnimal, value: "Other declared pest animal" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[MPestAnimalsDomain.NoneObserved] = 0;
                this.KeyIndex[MPestAnimalsDomain.AustralianPlagueLocustChortoicetusTerminifera] = 1;
                this.KeyIndex[MPestAnimalsDomain.CatOtherThanADomesticCatFelisCatus] = 2;
                this.KeyIndex[MPestAnimalsDomain.DingoCanisFamiliarisDingo] = 3;
                this.KeyIndex[MPestAnimalsDomain.DogOtherThanADomesticDogCanisFamiliaris] = 4;
                this.KeyIndex[MPestAnimalsDomain.EuropeanFoxVulpesVulpes] = 5;
                this.KeyIndex[MPestAnimalsDomain.EuropeanRabbitDomesticAndWildBreedsOryctolagusCuniculus] = 6;
                this.KeyIndex[MPestAnimalsDomain.FeralChitalAxisDeerAxisAxis] = 7;
                this.KeyIndex[MPestAnimalsDomain.FeralFallowDeerDamaDama] = 8;
                this.KeyIndex[MPestAnimalsDomain.FeralPigSusScrofa] = 9;
                this.KeyIndex[MPestAnimalsDomain.FeralRedDeerCervusElaphus] = 10;
                this.KeyIndex[MPestAnimalsDomain.FeralRusaDeerCervusTimorensis] = 11;
                this.KeyIndex[MPestAnimalsDomain.GoatOtherThanADomesticGoatCapraHircus] = 12;
                this.KeyIndex[MPestAnimalsDomain.MigratoryLocustLocustaMigratoria] = 13;
                this.KeyIndex[MPestAnimalsDomain.SpurThroatedLocustAustracrisGuttulosa] = 14;
                this.KeyIndex[MPestAnimalsDomain.YellowCrazyAntAnoplolepisGracilipes] = 15;
                this.KeyIndex[MPestAnimalsDomain.OtherDeclaredPestAnimal] = 16;
                this.ValueIndex = {};
                this.ValueIndex["None observed"] = 0;
                this.ValueIndex["Australian plague locust (Chortoicetus terminifera)"] = 1;
                this.ValueIndex["Cat, other than a domestic cat (Felis catus)"] = 2;
                this.ValueIndex["Dingo (Canis familiaris dingo)"] = 3;
                this.ValueIndex["Dog, other than a domestic dog (Canis familiaris)"] = 4;
                this.ValueIndex["European fox (Vulpes vulpes)"] = 5;
                this.ValueIndex["European rabbit (domestic and wild breeds) (Oryctolagus cuniculus)"] = 6;
                this.ValueIndex["Feral chital (axis) deer (Axis axis)"] = 7;
                this.ValueIndex["Feral fallow deer (Dama dama)"] = 8;
                this.ValueIndex["Feral pig (Sus scrofa)"] = 9;
                this.ValueIndex["Feral red deer (Cervus elaphus)"] = 10;
                this.ValueIndex["Feral rusa deer (Cervus timorensis)"] = 11;
                this.ValueIndex["Goat, other than a domestic goat (Capra hircus)"] = 12;
                this.ValueIndex["Migratory locust (Locusta migratoria)"] = 13;
                this.ValueIndex["Spur-throated locust (Austracris guttulosa)"] = 14;
                this.ValueIndex["Yellow crazy ant (Anoplolepis gracilipes)"] = 15;
                this.ValueIndex["Other declared pest animal"] = 16;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.MPestAnimalsDomain = MPestAnimalsDomain;
    Object.defineProperty(MPestAnimalsDomain, "NoneObserved", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(MPestAnimalsDomain, "AustralianPlagueLocustChortoicetusTerminifera", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(MPestAnimalsDomain, "CatOtherThanADomesticCatFelisCatus", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(MPestAnimalsDomain, "DingoCanisFamiliarisDingo", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 4
    });
    Object.defineProperty(MPestAnimalsDomain, "DogOtherThanADomesticDogCanisFamiliaris", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 5
    });
    Object.defineProperty(MPestAnimalsDomain, "EuropeanFoxVulpesVulpes", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 6
    });
    Object.defineProperty(MPestAnimalsDomain, "EuropeanRabbitDomesticAndWildBreedsOryctolagusCuniculus", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 7
    });
    Object.defineProperty(MPestAnimalsDomain, "FeralChitalAxisDeerAxisAxis", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 8
    });
    Object.defineProperty(MPestAnimalsDomain, "FeralFallowDeerDamaDama", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 9
    });
    Object.defineProperty(MPestAnimalsDomain, "FeralPigSusScrofa", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 10
    });
    Object.defineProperty(MPestAnimalsDomain, "FeralRedDeerCervusElaphus", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 11
    });
    Object.defineProperty(MPestAnimalsDomain, "FeralRusaDeerCervusTimorensis", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 12
    });
    Object.defineProperty(MPestAnimalsDomain, "GoatOtherThanADomesticGoatCapraHircus", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 13
    });
    Object.defineProperty(MPestAnimalsDomain, "MigratoryLocustLocustaMigratoria", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 14
    });
    Object.defineProperty(MPestAnimalsDomain, "SpurThroatedLocustAustracrisGuttulosa", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 15
    });
    Object.defineProperty(MPestAnimalsDomain, "YellowCrazyAntAnoplolepisGracilipes", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 16
    });
    Object.defineProperty(MPestAnimalsDomain, "OtherDeclaredPestAnimal", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 17
    });
    Object.defineProperty(MPestAnimalsDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
